import { Component, Input } from '@angular/core';
import { cardDetails } from '../../models/request.model';

@Component({
  selector: 'app-proof-card',
  imports: [],
  templateUrl: './proof-card.component.html',
  styleUrl: './proof-card.component.less'
})
export class ProofCardComponent {
  @Input() cardData!: cardDetails;
  @Input() isSelected = false;
  
  constructor() { }



}
